/* eslint-disable @typescript-eslint/camelcase */
import { PrintDataEntitas } from "@/domain/entities/Booking";
import { createI18n } from "vue-i18n";
import en from "@/i18n/locales/en";
import id from "@/i18n/locales/id";
import my from "@/i18n/locales/my";
import { headerSection } from "@/app/ui/modules/receipt-v2/layout/sections/header";
import { originDestination } from "@/app/ui/modules/receipt-v2/layout/sections/origin";
import {
  allPrices,
  variablesDefine
} from "@/app/ui/modules/receipt-v2/layout/part-layout/parts";
import { ursaSla } from "@/app/ui/modules/receipt-v2/layout/sections/ursa-sla";
import { weights } from "@/app/ui/modules/receipt-v2/layout/sections/weight";
import { DeliverySection } from "@/app/ui/modules/receipt-v2/layout/sections/delivery";
import { QuoteSection } from "@/app/ui/modules/receipt-v2/layout/sections/quote";
import { TarifSection } from "@/app/ui/modules/receipt-v2/layout/sections/tariff";
import { KoliSection } from "@/app/ui/modules/receipt-v2/layout/sections/koli";
import { getWaterMark } from "@/app/ui/modules/receipt-v2/layout/sections/watermark";
import { DhlFooter } from "@/app/ui/modules/receipt-v2/layout/sections/dhl-footer";

export const printReceiptDhl = async (
  params: {
    doc: any;
    bookingType: string;
    accountType: string;
    data: PrintDataEntitas;
    pieceData: any;
    barcode: string;
    vendorRefCode: string;
    barcodeValue: string;
    vendorRefCodeValue: string;
    logo: string;
    shipmentId: string;
    startX: number;
    startY: number;
  },
  language = "id"
) => {
  // LANGUAGE
  const i18nInstance = createI18n({
    legacy: false,
    locale: language,
    fallbackLocale: "id",
    globalInjection: false,
    messages: {
      en,
      id,
      my
    }
  });
  const translate = i18nInstance.global.t;

  const {
    doc,
    data,
    logo,
    startX,
    startY,
    shipmentId,
    bookingType,
    accountType
  } = params;
  const { logoAspectRatio, showCodRetail, isDfod } = await variablesDefine(
    doc,
    data,
    {
      shipmentId,
      logo,
      bookingType,
      accountType
    }
  );
  const { estimateSla, isBigpackVolume, isJumbopackvolume } = allPrices(data, {
    showCodRetail,
    isDfod,
    language
  });

  params.data.sttNoRefExternal = params.data.vendorDl.shipmentId;
  params.data.sttVendorRefferenceNo =
    params.data.vendorDl.deliveryConfirmationNo;

  let newParams = params;
  await getWaterMark(newParams);
  newParams = await headerSection(newParams, logoAspectRatio);
  originDestination(newParams, { startX, startY });
  ursaSla(newParams, estimateSla, { startX, startY }, translate);
  weights(newParams, { startX, startY }, isBigpackVolume, isJumbopackvolume);
  await DeliverySection(params, translate, language);
  KoliSection(params, translate);
  TarifSection(params, translate);
  const { startY: endContentY } = QuoteSection(params, translate);
  await DhlFooter({ ...newParams, startY: endContentY }, translate);
};
